import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { cn } from '../../../../shared/cn';
type ScrollUpButtonProps = {
  targetRef: React.RefObject<HTMLDivElement | null>;
};
export function ScrollUpButton(t0) {
  const $ = _c(5);
  const {
    targetRef
  } = t0;
  let t1;
  if ($[0] !== targetRef) {
    t1 = () => {
      const target = targetRef.current;
      if (target) {
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - 10,
          behavior: "smooth"
        });
      }
    };
    $[0] = targetRef;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleClick = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = cn("fixed right-8 bottom-8 z-50 h-10 w-10 rounded-full bg-algoprimary text-white shadow-lg lg:hidden", "transition-opacity duration-300");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== handleClick) {
    t3 = <button type="button" onClick={handleClick} className={t2}>↑</button>;
    $[3] = handleClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}